import { render, staticRenderFns } from "./OnForWorkC5.vue?vue&type=template&id=f8157708&"
import script from "./OnForWorkC5.vue?vue&type=script&lang=js&"
export * from "./OnForWorkC5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports